import React from "react";
import {
  LogContextValueInterface,
  Cart,
  Product,
} from "@pepdirect/shared/types";
import { CartFragment } from "services/graphql/generated";

export const LogContext = React.createContext<LogContextValueInterface>({
  useLogPageView: (_pageName: string, _key?: string) => {},
  useLogProductViewed: (_product: Product | null) => {},
  useLogCartViewed: (_cart: Cart | CartFragment | null) => {},
});
